import { ReactNode, useMemo } from 'react';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';

const TEAL = '#00bfb3';

/**
 * Wraps its children in a theme whose primary colour is Pogozo teal, so every
 * default MUI Button / Switch / ToggleButton inside (including the calendar's
 * dialogs, which render in the same React tree) picks up the brand colour
 * without touching each control (POGO-13214).
 */
const PogozoTealTheme = ({ children }: { children: ReactNode }) => {
    const base = useTheme();
    const theme = useMemo(() => createTheme(base, { palette: { primary: { main: TEAL, contrastText: '#ffffff' } } }), [base]);
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default PogozoTealTheme;
